import jsPDF from "jspdf";
import { autoTable } from 'jspdf-autotable';
import moment from "moment";
import visionLogo from "../../images/vision-logo.png";
import { formatAmount, formatInvoiceNo } from "../helpers/common";

export const generateCrateCreditPdf = async (creditData, isEmail = false) => {
    const doc = new jsPDF('p', 'mm', 'a4');

    // Logo 
    doc.addImage(visionLogo, "PNG", 160, 7, 44, 12);
    doc.setFontSize(23);

    // Credit Text
    doc.setFont("primary", "bold")
    doc.text("Credit Note", 10, 15);

    // Customer Details
    doc.setFontSize(10);
    doc.text(`${creditData.tblCustomer?.CustomerName}`, 10, 30);
    let invoiceAddress = creditData.tblCustomer?.InvoiceAddress1 || creditData.tblCustomer?.InvoiceAddress2 || creditData.tblCustomer?.InvoiceAddress3;
    doc.text(`${invoiceAddress}`, 10, 35);
    doc.text(`${creditData?.tblCustomer?.InvoicePostCode}`, 10, 40);
    doc.text("Credit Note :", 130, 30);
    doc.text(`${formatInvoiceNo(creditData.CNID, "CCR")}`, 160, 30);
    doc.text("Reference :", 133, 35);
    doc.text(`${creditData.ReferenceNo}`, 160, 35);
    doc.text("Date :", 141, 40);
    doc.text(`${moment(creditData?.ReturnDate, "YYYY-MM-DD").format("MM/DD/YYYY")}`, 160, 40);
    doc.text("Code :", 140, 45);
    doc.text(`${creditData.tblCustomer?.CustomerCode}`, 160, 45);


    // Variables Declarations 
    const products = creditData.creditDetails;
    let subTotal = 0;
    let totalQty = 0;

    let productsColumnStyles = {
        0: { cellWidth: 30, halign: "center", },
        1: { cellWidth: 130, halign: "left" },
        2: { cellWidth: 30, halign: "right" },
    }

    // Create Data for Table Body

    let productsTableBody = products.map((product, productIndex) => {
        let ProductName = ` ${creditData?.units?.find(unit => unit.value == product.UnitID)?.label || ''} ${creditData.crates?.find(crate => crate.ContainerID == product.ContainerID)?.label || ''}`;
        let Price = ` ${formatAmount(product.CrateCreditAmt)} `
        subTotal += parseFloat(product.CrateCreditAmt || 0);
        totalQty += parseInt(product.Qty || 0);

        return [product.Qty, ProductName, Price];
    });

    // Product Details Table
    autoTable(doc, {
        startY: 50,
        columnStyles: productsColumnStyles,
        head: [["Qty", "Details", "Value"]],
        body: productsTableBody,
        theme: "plain",
        headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            lineWidth: 0.2
        },
        styles: { fontSize: 10, cellPadding: 1 },
        margin: { top: 8, bottom: 8, left: 8, right: 8 },
        showHead: "firstPage",
    });

    // Check End of the Page and Move to new page if there no required space left.
    const pageHeight = doc.internal.pageSize.height;
    let yPosition = doc.lastAutoTable.finalY + 5;

    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.line(10, yPosition - 3, doc.internal.pageSize.width - 8, yPosition - 3);

    if (yPosition + 10 > pageHeight) {
        doc.addPage();
        yPosition = 10;
    }

    // Credit Total Summary
    doc.setFontSize(10);
    doc.text(`${totalQty}`, 22, yPosition + 2);
    doc.text("Subtotal :", 165, yPosition + 2);
    doc.text(`${formatAmount(subTotal)}`, 185, yPosition + 2);

    // Footer Text
    yPosition = doc.lastAutoTable.finalY + 5;

    if (yPosition + 50 > pageHeight) {
        doc.addPage();
        yPosition = 10;
    }

    doc.setFontSize(8);
    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.line(10, doc.internal.pageSize.height - 50, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 50);

    let startXText = doc.internal.pageSize.getWidth() - 200;
    let startYText = doc.internal.pageSize.getHeight() - 54;

    const rightTextArray = [
        "Vision Produce Pty Ltd",
        "ABN 11 098 952 768",
        "Mail Point 103, Market City,",
        "280 Bannister Road",
        "Canning Vale WA 6155",
        "Telephone: (08) 9456 5953",
        "Facsimile: (08) 9456 5948",
        "E-mail: accounts@visionproduce.com.au"
    ];

    startXText = doc.internal.pageSize.getWidth() - 70;
    startYText = doc.internal.pageSize.getHeight() - 40;
    rightTextArray.map((text, index) => {
        startYText += 4;
        if (index == 0) {
            doc.setFont("helvetica", "bold");
            doc.text(text, startXText, startYText);
            doc.setFont("helvetica", "normal");
        } else {
            doc.text(text, startXText, startYText);
        }
    })

    // Footer Pagination
    const totalPageCount = doc.internal.pages.length - 1;

    for (let i = 1; i <= totalPageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor("#787a80")
        const pageText = `Page ${i} of ${totalPageCount}`;
        doc.text(
            pageText,
            doc.internal.pageSize.getWidth() - 25,
            doc.internal.pageSize.getHeight() - 3,
        );
    }

    const pdf = doc.output('arraybuffer');
    if (isEmail) {
        return pdf;
    }
    const blob = new Blob([pdf], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
}